'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

export function LoadingPhoneAnimation(props: IAnimationProps) {
  const loadAnimation = () => import('./raw-json/loading-phone-animation.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="LoadingPhoneAnimation"
    />
  );
}
